module.exports = __webpack_public_path__ + "static/media/pos_customer_management.f89a7928.jpg";